module.exports = __webpack_public_path__ + "ie.svg?ce6c7d810f03854cd7517de4dad68c5d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ie.svg
// module id = 1413
// module chunks = 0